import { activateLightSidebarTheme } from 'shared/sidebar';

document.addEventListener('DOMContentLoaded', () => {
  activateLightSidebarTheme();
});
